import {
  mdiTwitter,
  mdiFacebook,
  mdiYoutube,
  mdiPinterest,
  mdiLinkedin,
  mdiInstagram,
  mdiReddit,
  mdiWhatsapp,
  mdiLink,
  mdiCrownOutline,
  mdiRocketLaunchOutline,
  mdiHeart,
  mdiShareVariant,
  mdiCached,
  mdiPuzzle,
  mdiAccountPlus,

  mdiEye,
  mdiEyeOff,
  mdiMenu,
  mdiHome,
  mdiArrowUpDownBold,
  mdiMagnify,
  mdiAccountCircleOutline,
  mdiBookOpenVariant,
  mdiNewspaper,
  mdiNewspaperPlus,
  mdiGoogleClassroom,
  mdiImageMultipleOutline,
  mdiInformationOutline,
  mdiAccountGroup,
  mdiFormatListNumbered,
  mdiSchoolOutline,
  mdiPaletteOutline,
  mdiWalletMembership,
  mdiHelpCircleOutline,
  mdiSecurity,
  mdiMessageAlertOutline,
  mdiWeb,
  mdiClose,
  mdiChevronUp,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiLightbulbOn,
  mdiBellOutline,
  mdiCloudUploadOutline,
  mdiLogout,
  mdiLeadPencil,
  mdiCogOutline,
  mdiSwapHorizontal,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiDotsHorizontal,
  mdiPlus,
  mdiFormatTextVariantOutline,

  mdiUndo,
  // studio
  mdiFileMultiple,

  mdiCheck,
  mdiAlert,
  // classes
  mdiFilmstrip,
  mdiEarth,
  mdiBank,
  mdiForum,
  mdiArchiveArrowDownOutline,
  mdiArchiveArrowUpOutline,
  mdiKeyOutline,

  // logged out view
  mdiPlay,
  mdiStop,
  mdiBrush,
  mdiMusicNote,
  mdiRun,
  mdiCallSplit,
  mdiTranslate
} from '@mdi/js' // mdi-menu

export default function () {
  return {
    breakpoint: {
      scrollBarWidth: 0, // Adjust scroll bar width if needed
    },
    theme: {
      dark: false, // Set light theme as default
      options: { customProperties: true }, // Use CSS variables for themes
      themes: {
        light: {
          primary: '#1976D2', // Blue
          secondary: '#004B88', // Dark Blue
          accent: '#FF883E', // Orange
          error: '#E55858', // Red
          warning: '#FFAD34', // Yellow
          info: '#47A7F5', // Light Blue
          success: '#4DAE52', // Green
        },
      },
    },
    icons: {
      iconfont: 'mdiSvg', // Use SVG icons
      values: {
        mdiTwitter,
        mdiFacebook,
        mdiYoutube,
        mdiPinterest,
        mdiLinkedin,
        mdiInstagram,
        mdiReddit,
        mdiWhatsapp,
        mdiLink,
        mdiCrownOutline,
        mdiRocketLaunchOutline,
        mdiHeart,
        mdiShareVariant,
        mdiCached,
        mdiPuzzle,
        mdiAccountPlus,

        mdiEye,
        mdiEyeOff,
        mdiHome,
        mdiMenu,
        mdiArrowUpDownBold,
        mdiMagnify,
        mdiAccountCircleOutline,
        mdiBookOpenVariant,
        mdiNewspaper,
        mdiNewspaperPlus,
        mdiGoogleClassroom,
        mdiImageMultipleOutline,
        mdiInformationOutline,
        mdiAccountGroup,
        mdiFormatListNumbered,
        mdiSchoolOutline,
        mdiPaletteOutline,
        mdiWalletMembership,
        mdiHelpCircleOutline,
        mdiSecurity,
        mdiMessageAlertOutline,
        mdiWeb,
        mdiClose,
        mdiChevronUp,
        mdiChevronDown,
        mdiChevronLeft,
        mdiChevronRight,
        mdiLightbulbOn,
        mdiBellOutline,
        mdiCloudUploadOutline,
        mdiLogout,
        mdiLeadPencil,
        mdiCogOutline,
        mdiSwapHorizontal,
        mdiDeleteOutline,
        mdiDotsVertical,
        mdiDotsHorizontal,
        mdiPlus,
        mdiFormatTextVariantOutline,

        mdiUndo,
        mdiFileMultiple, // studio
        mdiCheck,
        mdiAlert,
        mdiFilmstrip, // classes
        mdiEarth,
        mdiBank,
        mdiForum,
        mdiArchiveArrowDownOutline,
        mdiArchiveArrowUpOutline,
        mdiKeyOutline,

        mdiBrush,
        mdiMusicNote,
        mdiRun,
        mdiCallSplit,
        mdiPlay,
        mdiStop,
        // socials
        mdiTwitter,
        mdiTwitter,
        mdiFacebook,
        mdiYoutube,
        mdiPinterest,
        mdiLinkedin,
        mdiInstagram,
        mdiReddit,
        mdiWhatsapp,
        mdiLink,
        mdiTranslate
      }
    }
  }
}
